<template>
  <div>
<!--    <page-header></page-header>-->

    <router-view class="overflow-y-auto"></router-view>
  </div>
</template>
<script>
import PageHeader from '@/components/common/PageHeader.vue';

export default {
  computed: {
  },
  components: {
    PageHeader,
  },
};
</script>
